import './index.css'
import { X } from 'lucide-react'
import type { Transaction } from '../../types'

interface DeleteGroupModalProps {
  transaction: Transaction | null
  onDeleteOne: () => void
  onDeleteAll: () => void
  onClose: () => void
}

export default function DeleteGroupModal({ transaction, onDeleteOne, onDeleteAll, onClose }: DeleteGroupModalProps) {
  if (!transaction) return null

  const baseTitle = transaction.title.replace(/\s*\(\d+\/\d+\)$/, '')
  const total = transaction.installment_count ?? 1

  return (
    <div className="bc-delgroup-overlay" onClick={onClose}>
      <div className="bc-delgroup" onClick={e => e.stopPropagation()}>
        <div className="bc-delgroup__header">
          <h3 className="bc-delgroup__title">Excluir parcelas</h3>
          <button className="bc-delgroup__close" aria-label="Fechar" onClick={onClose}>
            <X size={16} />
          </button>
        </div>

        <div className="bc-delgroup__body">
          <p className="bc-delgroup__info">
            <strong>"{baseTitle}"</strong> — {total} {total === 1 ? 'parcela' : 'parcelas'} no total. O que deseja excluir?
          </p>
        </div>

        <div className="bc-delgroup__footer">
          <button className="bc-btn bc-btn--expense bc-btn--sm" onClick={onDeleteAll}>
            Excluir todas ({total})
          </button>
          <button className="bc-btn bc-btn--ghost bc-btn--sm" onClick={onDeleteOne}>
            Excluir apenas esta parcela
          </button>
          <button className="bc-btn bc-btn--ghost bc-btn--sm" onClick={onClose}>
            Cancelar
          </button>
        </div>
      </div>
    </div>
  )
}
